import type { IconData } from '@stacksjs/iconify-core'

export const newsletterF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 .565h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2m3 8a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2zm10-5v2h2v-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default newsletterF
